import { PersistenceUnavailableError } from '@/core/persistence/errors'
import { DB_NAME, DB_VERSION, StoreName } from '@/core/persistence/types'

export const UPDATED_AT_INDEX = 'updatedAt'

export function openDatabase(): Promise<IDBDatabase> {
  if (typeof indexedDB === 'undefined') throw new PersistenceUnavailableError()

  return new Promise((resolve, reject) => {
    let request: IDBOpenDBRequest
    try {
      request = indexedDB.open(DB_NAME, DB_VERSION)
    } catch (error) {
      reject(new PersistenceUnavailableError('Could not open browser storage.', error))
      return
    }

    request.onupgradeneeded = () => {
      const database = request.result
      const transaction = request.transaction
      if (!transaction) throw new PersistenceUnavailableError('Browser storage upgrade is missing its transaction.')
      const recentEdits = database.objectStoreNames.contains(StoreName.RecentEdits)
        ? transaction.objectStore(StoreName.RecentEdits)
        : database.createObjectStore(StoreName.RecentEdits, { keyPath: 'id' })
      if (!recentEdits.indexNames.contains(UPDATED_AT_INDEX)) {
        recentEdits.createIndex(UPDATED_AT_INDEX, UPDATED_AT_INDEX)
      }
      if (!database.objectStoreNames.contains(StoreName.SharedInbox)) {
        database.createObjectStore(StoreName.SharedInbox, { keyPath: 'id' })
      }
    }
    request.onerror = () => reject(new PersistenceUnavailableError('Could not open browser storage.', request.error))
    request.onblocked = () => reject(new PersistenceUnavailableError('Browser storage is blocked by another tab.'))
    request.onsuccess = () => {
      const database = request.result
      if (!database.objectStoreNames.contains(StoreName.RecentEdits)
        || !database.objectStoreNames.contains(StoreName.SharedInbox)) {
        database.close()
        reject(new PersistenceUnavailableError('Browser storage is missing a required object store.'))
        return
      }
      const transaction = database.transaction([StoreName.RecentEdits, StoreName.SharedInbox], 'readonly')
      const recentEdits = transaction.objectStore(StoreName.RecentEdits)
      const sharedInbox = transaction.objectStore(StoreName.SharedInbox)
      if (recentEdits.keyPath !== 'id' || !recentEdits.indexNames.contains(UPDATED_AT_INDEX)) {
        database.close()
        reject(new PersistenceUnavailableError('Recent-edit storage has an invalid object-store configuration.'))
        return
      }
      if (sharedInbox.keyPath !== 'id') {
        database.close()
        reject(new PersistenceUnavailableError('Shared Inbox storage has an invalid object-store configuration.'))
        return
      }
      resolve(database)
    }
  })
}
